import ModalExpSelect from '../ModalExpSelect/ModalExpSelect'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'

const renderExpDateField = ({ translate, item }) => {
    const monthOptionsFactory = () => {
        const months = []
        for (let i = 1; i <= 12; i++) {
            const month = i < 10 ? '0' + i : i
            months.push(month.toString())
        }
        return months
    }

    const yearOptionsFactory = () => {
        const currentYear = new Date().getFullYear()
        const range = 10
        const years = []
        for (let i = 0; i <= range; i++) {
            years.push(`${currentYear + i}`)
        }
        return years
    }

    const [month, year] = (item.value || '').split('/')

    return (
        <ModalExpSelect
            label={translate(item.key)}
            onSet={(month, year) => {
                StoreCheckout.SetCreditCard({ key: item.key }, { month, year })
            }}
            options={{ month: monthOptionsFactory(), year: yearOptionsFactory() }}
            value={{ month: month || '', year: year ? '20' + year : '' }}
        />
    )
}

export default renderExpDateField

